import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import InvoiceItem from './InvoiceItem';
import InvoiceModal from './InvoiceModal';
import InputGroup from 'react-bootstrap/InputGroup';

class InvoiceForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      currency: '$',
      currentDate: '',
      invoiceNumber: 1,
      dateOfIssue: '',
      billTo: '',
      billToEmail: '',
      billToAddress: '',
      billFrom: '',
      billFromEmail: '',
      billFromAddress: '',
      notes: '',
      total: '0.00',
      subTotal: '0.00',
      taxRate: '',
      taxAmmount: '0.00',
      discountRate: '',
      discountAmmount: '0.00',
      isDarkMode: false // Added state for dark mode
    };
    this.state.items = [
      {
        id: 0,
        name: '',
        description: '',
        price: '1.00',
        quantity: 1
      }
    ];
    this.editField = this.editField.bind(this);
    this.toggleDarkMode = this.toggleDarkMode.bind(this); // Bind the toggle method
    this.sceneRef = React.createRef();  // Reference to the Three.js canvas
  }

  componentDidMount(prevProps) {
    this.handleCalculateTotal();
  }

  handleRowDel(items) {
    var index = this.state.items.indexOf(items);
    this.state.items.splice(index, 1);
    this.setState(this.state.items);
  }

  handleAddEvent(evt) {
    var id = (+new Date() + Math.floor(Math.random() * 999999)).toString(36);
    var items = {
      id: id,
      name: '',
      price: '1.00',
      description: '',
      quantity: 1
    }
    this.state.items.push(items);
    this.setState(this.state.items);
  }

  handleCalculateTotal() {
    var items = this.state.items;
    var subTotal = 0;

    items.forEach(function(items) {
      subTotal = parseFloat(subTotal + (parseFloat(items.price).toFixed(2) * parseInt(items.quantity))).toFixed(2);
    });

    this.setState({
      subTotal: parseFloat(subTotal).toFixed(2)
    }, () => {
      this.setState({
        taxAmmount: parseFloat(parseFloat(subTotal) * (this.state.taxRate / 100)).toFixed(2)
      }, () => {
        this.setState({
          discountAmmount: parseFloat(parseFloat(subTotal) * (this.state.discountRate / 100)).toFixed(2)
        }, () => {
          this.setState({
            total: ((subTotal - this.state.discountAmmount) + parseFloat(this.state.taxAmmount))
          });
        });
      });
    });
  }

  editField = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
    this.handleCalculateTotal();
  };

  onItemizedItemEdit(evt) {
    var item = {
      id: evt.target.id,
      name: evt.target.name,
      value: evt.target.value
    };
    var items = this.state.items.slice();
    var newItems = items.map(function(items) {
      for (var key in items) {
        if (key === item.name && items.id === item.id) {
          items[key] = item.value;
        }
      }
      return items;
    });
    this.setState({ items: newItems });
    this.handleCalculateTotal();
  }


  onCurrencyChange = (selectedOption) => {
    this.setState(selectedOption);
  };

  openModal = (event) => {
    event.preventDefault();
    this.handleCalculateTotal();
    this.setState({ isOpen: true });
  };

  closeModal = (event) => this.setState({ isOpen: false });

  // Method to toggle dark mode
  toggleDarkMode() {
    this.setState(prevState => ({
      isDarkMode: !prevState.isDarkMode
    }));
  }

  render() {
    // Define dynamic styles based on the current mode
    const formStyle = {
      backgroundColor: this.state.isDarkMode ? '#4B3621' : '#f0f8ff',
      padding: '20px',
      borderRadius: '15px',
      fontFamily: 'Arial, sans-serif',
      color: this.state.isDarkMode ? '#f0f0f0' : '#000000'
    };

    const cardStyle = {
      padding: '20px',
      borderRadius: '15px',
      backgroundColor: this.state.isDarkMode ? '#3a2a1a' : '#f9f9f9',
      border: this.state.isDarkMode ? '1px solid #555555' : '1px solid #007bff'
    };

    const labelStyle = {
      color: this.state.isDarkMode ? '#f0f0f0' : '#007bff',
      fontFamily: 'Verdana, sans-serif'
    };

    const moneyTextStyle = {
      color: this.state.isDarkMode ? '#ffffff' : '#000000',
      fontFamily: 'Verdana, sans-serif'
    };

    const inputStyle = {
      backgroundColor: this.state.isDarkMode ? '#5a4b3e' : '#ffffff',
      color: this.state.isDarkMode ? '#f0f0f0' : '#000000',
      borderRadius: '8px',
      fontFamily: 'Verdana, sans-serif'
    };

    const buttonStyle = {
      borderRadius: '20px',
      fontFamily: 'Verdana, sans-serif'
    };

    const toggleButtonStyle = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      borderRadius: '20px',
      fontFamily: 'Verdana, sans-serif'
    };

    return (
      <>
        {/* Toggle Dark Mode Button */}
        <Button 
          variant={this.state.isDarkMode ? "light" : "dark"} 
          onClick={this.toggleDarkMode} 
          style={toggleButtonStyle}
        >
          {this.state.isDarkMode ? "Light Mode" : "Dark Mode"}
        </Button>

        <Form onSubmit={this.openModal} style={formStyle}>
          <Row>
            <Col md={8} lg={9}>
              <Card style={cardStyle}>
                <div className="d-flex flex-row align-items-start justify-content-between mb-3">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column">
                      <div className="mb-2">
                        <span className="fw-bold" style={labelStyle}>Current&nbsp;Date:&nbsp;</span>
                        <span className="current-date" style={this.state.isDarkMode ? { color: '#ffffff' } : {}}>
                          {new Date().toLocaleDateString()}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-row align-items-center">
                      <span className="fw-bold d-block me-2" style={labelStyle}>Due&nbsp;Date:</span>
                      <Form.Control 
                        type="date" 
                        value={this.state.dateOfIssue} 
                        name={"dateOfIssue"} 
                        onChange={(event) => this.editField(event)} 
                        style={{ 
                          maxWidth: '150px', 
                          ...inputStyle 
                        }} 
                        required="required" 
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-row align-items-center">
                    <span className="fw-bold me-2" style={labelStyle}>Invoice&nbsp;Number:&nbsp;</span>
                    <Form.Control 
                      type="number" 
                      value={this.state.invoiceNumber} 
                      name={"invoiceNumber"} 
                      onChange={(event) => this.editField(event)} 
                      min="1" 
                      style={{ 
                        maxWidth: '70px', 
                        ...inputStyle 
                      }} 
                      required="required" 
                    />
                  </div>
                </div>
                <hr style={{ borderTop: this.state.isDarkMode ? '1px solid #555555' : '1px solid #007bff' }} />
                <Row className="mb-5">
                  <Col>
                    <Form.Label className="fw-bold" style={labelStyle}>Bill to:</Form.Label>
                    <Form.Control 
                      placeholder={"Who is this invoice to?"} 
                      rows={3} 
                      value={this.state.billTo} 
                      type="text" 
                      name="billTo" 
                      className="my-2" 
                      onChange={(event) => this.editField(event)} 
                      autoComplete="name" 
                      required="required" 
                      style={inputStyle}
                    />
                    <Form.Control 
                      placeholder={"Email address"} 
                      value={this.state.billToEmail} 
                      type="email" 
                      name="billToEmail" 
                      className="my-2" 
                      onChange={(event) => this.editField(event)} 
                      autoComplete="email" 
                      required="required" 
                      style={inputStyle}
                    />
                    <Form.Control 
                      placeholder={"Billing address"} 
                      value={this.state.billToAddress} 
                      type="text" 
                      name="billToAddress" 
                      className="my-2" 
                      autoComplete="address" 
                      onChange={(event) => this.editField(event)} 
                      required="required" 
                      style={inputStyle}
                    />
                  </Col>
                  <Col>
                    <Form.Label className="fw-bold" style={labelStyle}>Bill from:</Form.Label>
                    <Form.Control 
                      placeholder={"Who is this invoice from?"} 
                      rows={3} 
                      value={this.state.billFrom} 
                      type="text" 
                      name="billFrom" 
                      className="my-2" 
                      onChange={(event) => this.editField(event)} 
                      autoComplete="name" 
                      required="required" 
                      style={inputStyle}
                    />
                    <Form.Control 
                      placeholder={"Email address"} 
                      value={this.state.billFromEmail} 
                      type="email" 
                      name="billFromEmail" 
                      className="my-2" 
                      onChange={(event) => this.editField(event)} 
                      autoComplete="email" 
                      required="required" 
                      style={inputStyle}
                    />
                    <Form.Control 
                      placeholder={"Billing address"} 
                      value={this.state.billFromAddress} 
                      type="text" 
                      name="billFromAddress" 
                      className="my-2" 
                      autoComplete="address" 
                      onChange={(event) => this.editField(event)} 
                      required="required" 
                      style={inputStyle}
                    />
                  </Col>
                </Row>
                <InvoiceItem 
                  onItemizedItemEdit={this.onItemizedItemEdit.bind(this)} 
                  onRowAdd={this.handleAddEvent.bind(this)} 
                  onRowDel={this.handleRowDel.bind(this)} 
                  currency={this.state.currency} 
                  items={this.state.items} 
                />
                <Row className="mt-4 justify-content-end">
                  <Col lg={6}>
                    <div className="d-flex flex-row align-items-start justify-content-between">
                      <span className="fw-bold" style={labelStyle}>Subtotal:</span>
                      <span style={moneyTextStyle}>{this.state.currency}{this.state.subTotal}</span>
                    </div>
                    <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                      <span className="fw-bold" style={labelStyle}>Discount:</span>
                      <span style={moneyTextStyle}>{this.state.currency}{this.state.discountAmmount || 0}</span>
                    </div>
                    <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                      <span className="fw-bold" style={labelStyle}>Tax:</span>
                      <span style={moneyTextStyle}>{this.state.currency}{this.state.taxAmmount || 0}</span>
                    </div>
                    <hr style={{ borderTop: this.state.isDarkMode ? '1px solid #555555' : '1px solid #007bff' }} />
                    <div className="d-flex flex-row align-items-start justify-content-between" style={{ fontSize: '1.125rem' }}>
                      <span className="fw-bold" style={labelStyle}>Total:</span>
                      <span className="fw-bold" style={moneyTextStyle}>{this.state.currency}{this.state.total || 0}</span>
                    </div>
                  </Col>
                </Row>
                <hr style={{ borderTop: this.state.isDarkMode ? '1px solid #555555' : '1px solid #007bff' }} />
                <Form.Label className="fw-bold" style={labelStyle}>Notes:</Form.Label>
                <Form.Control 
                  placeholder="Thanks for your business!" 
                  name="notes" 
                  value={this.state.notes} 
                  onChange={(event) => this.editField(event)} 
                  as="textarea" 
                  className="my-2" 
                  rows={1} 
                  style={inputStyle}
                />
              </Card>
            </Col>
            <Col md={4} lg={3}>
              <div className="sticky-top pt-md-3 pt-xl-4">
                <Button 
                  variant={this.state.isDarkMode ? "light" : "success"} 
                  type="submit" 
                  className="d-block w-100" 
                  style={buttonStyle}
                >
                  Review Invoice
                </Button>
                <InvoiceModal 
                  showModal={this.state.isOpen} 
                  closeModal={this.closeModal} 
                  info={this.state} 
                  items={this.state.items} 
                  currency={this.state.currency} 
                  subTotal={this.state.subTotal} 
                  taxAmmount={this.state.taxAmmount} 
                  discountAmmount={this.state.discountAmmount} 
                  total={this.state.total} 
                />
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold" style={labelStyle}>Currency:</Form.Label>
                  <Form.Select 
                    onChange={event => this.onCurrencyChange({ currency: event.target.value })} 
                    className="btn btn-light my-1" 
                    aria-label="Change Currency"
                    style={{ 
                      ...inputStyle, 
                      borderRadius: '8px', 
                      fontFamily: 'Verdana, sans-serif' 
                    }}
                  >
                    <option value="$">USD (United States Dollar)</option>
                    <option value="£">GBP (British Pound Sterling)</option>
                    <option value="¥">JPY (Japanese Yen)</option>
                    <option value="$">CAD (Canadian Dollar)</option>
                    <option value="$">AUD (Australian Dollar)</option>
                    <option value="$">SGD (Singapore Dollar)</option>
                    <option value="¥">CNY (Chinese Renminbi)</option>
                    <option value="₿">BTC (Bitcoin)</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="my-3">
                  <Form.Label className="fw-bold" style={labelStyle}>Tax rate:</Form.Label>
                  <InputGroup className="my-1 flex-nowrap">
                    <Form.Control 
                      name="taxRate" 
                      type="number" 
                      value={this.state.taxRate} 
                      onChange={(event) => this.editField(event)} 
                      className="bg-white border" 
                      placeholder="0.0" 
                      min="0.00" 
                      step="0.01" 
                      max="100.00" 
                      style={inputStyle}
                    />
                    <InputGroup.Text className="bg-light fw-bold text-secondary small" style={{ borderRadius: '0 8px 8px 0' }}>%</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                <Form.Group className="my-3">
                  <Form.Label className="fw-bold" style={labelStyle}>Discount rate:</Form.Label>
                  <InputGroup className="my-1 flex-nowrap">
                    <Form.Control 
                      name="discountRate" 
                      type="number" 
                      value={this.state.discountRate} 
                      onChange={(event) => this.editField(event)} 
                      className="bg-white border" 
                      placeholder="0.0" 
                      min="0.00" 
                      step="0.01" 
                      max="100.00" 
                      style={inputStyle}
                    />
                    <InputGroup.Text className="bg-light fw-bold text-secondary small" style={{ borderRadius: '0 8px 8px 0' }}>%</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </div>
            </Col>
            {/* Three.js 3D Cube */}
            <Col md={12}>
              <div ref={this.sceneRef} style={{ marginTop: '30px', width: '100%', display: 'flex', justifyContent: 'center' }}></div>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default InvoiceForm;
